require('./countries-edit-container.scss')

module.exports = {
  template: require('./countries-edit-container.pug')()
  controller: require('./countries-edit-container.ctrl')
  bindings:
    country: '<'
}
